import { Modal, Form, Input, Button, Radio, Row, Col } from "antd";
import PropTypes from "prop-types";
import { useState } from "react"; // Need useState for year/month selection state

// Helper arrays for year and month options
const YEAR_OPTIONS = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
]; // The image has 1-36 visible
const MONTH_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]; // The image has 1-11 visible
const WHEN = [
  2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013,
  2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005, 2004, 2003, 2002, 2001, 2000,
];
const family_options=["Father","Mother","Grandfather,Grandmother,Spouse","Brother","Sister","Aunt"]

export default function MedicalDetailModal({
  open,
  onClose,
  onSave,
  selectedItem,
  type,
}) {
  const [form] = Form.useForm();

  // State to manage the "Since" duration selection
  const [selectedYears, setSelectedYears] = useState(null); // Default to 3 years like the image
  const [since_when_year, setSinceWhenYear] = useState(null); // Default to 3 years like the image

  const [selectedMonths, setSelectedMonths] = useState(null); // Default to 0 months
  const [family_relation, setFamilyRelation] = useState("");

const handleSave = () => {
  form.validateFields().then((values) => {
    onSave({
      note: values.note,

      // send everything
      selectedYears,
      selectedMonths,
      since_when_year,
      family_relation,
    });

    onClose();
     form.resetFields();

  setSelectedYears(null);
  setSelectedMonths(null);
  setSinceWhenYear(null);
  setFamilyRelation("");
  });
};



  // Custom button style to match the image's rounded look
  const buttonStyle = {
    borderRadius: "12px", // Custom rounding for the button style
    height: "40px",
    lineHeight: "40px",
    padding: "0 12px",
    textAlign: "center",
    marginRight: "8px",
  };

  // Custom Radio Group style to remove the border around the group
  const radioGroupStyle = {
    border: "none",
    boxShadow: "none",
    display: "flex",
    flexWrap: "wrap",
  };

  // Custom Form Item label style for the "Since" field
  const labelStyle = {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "8px",
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={<Button onClick={handleSave}>Save</Button>}
      title={selectedItem?.name} // Adjusted title to match the image context
      destroyOnClose
      width={350} // Make the modal slightly narrower to feel more mobile-like
      style={{ top: 20 }} // Bring the modal up slightly
    >
      <Form
        layout="vertical"
        form={form}
        style={{ padding: "16px 0" }} // Add some padding inside the form
      >
        {/* --- Since Duration Field --- */}
        <div style={{ marginBottom: "24px" }}>
          <div style={labelStyle}>Since</div>

          {/* Years Selection */}
          {type == "H/O Procedures" ? (
            <Row
              gutter={[8, 8]}
              align="middle"
              style={{ marginBottom: "16px" }}
            >
              <Col>
                <span
                  className="ant-form-item-label"
                  style={{ fontWeight: "normal" }}
                >
                  when
                </span>
              </Col>
              <Col flex="auto">
                {/* Add a wrapper div for horizontal scrolling */}
                <div
                  style={{
                    overflowX: "auto", // Enables horizontal scrolling
                    whiteSpace: "nowrap", // Prevents the buttons from wrapping to the next line
                    paddingBottom: "8px", // Optional: Add padding to prevent the scrollbar from overlapping content
                  }}
                >
                  <Radio.Group
                    value={since_when_year}
                    onChange={(e) => setSinceWhenYear(e.target.value)}
                    buttonStyle="solid"
                    // Note: The radioGroupStyle should ensure 'display: flex' is set
                    // but without 'flex-wrap: wrap' for this to work correctly.
                    // If radioGroupStyle includes 'flex-wrap: wrap', remove it.
                    style={{ ...radioGroupStyle, width: "max-content" }} // Ensure the group takes up all necessary space
                  >
                    {WHEN.map((yr) => (
                      <Radio.Button key={yr} value={yr} style={buttonStyle}>
                        {yr}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                </div>
              </Col>
            </Row>
          ) : type == "Family History" ? (
            <Row
              gutter={[8, 8]}
              align="middle"
              style={{ marginBottom: "16px" }}
            >
             
              <Col flex="auto">
                {/* The horizontal scrolling wrapper is removed */}
                <Radio.Group
                  value={family_relation}
                  onChange={(e) => setFamilyRelation(e.target.value)}
                  // Remove buttonStyle="solid"
                  // Remove the horizontal scrolling styles and width from the Radio.Group
                >
                  {family_options.map((yr) => (
                    // Switch from Radio.Button to standard Radio component
                    // Apply a style to make each radio item take the full width and stack vertically
                    <div key={yr} style={{ marginBottom: "8px" }}>
                      <Radio value={yr} style={{ display: "block" }}>
                        {yr}
                      </Radio>
                    </div>
                  ))}
                </Radio.Group>
              </Col>
            </Row>
          ) : (
            <>
              <Row
                gutter={[8, 8]}
                align="middle"
                style={{ marginBottom: "16px" }}
              >
                <Col>
                  <span
                    className="ant-form-item-label"
                    style={{ fontWeight: "normal" }}
                  >
                    yrs
                  </span>
                </Col>
                <Col flex="auto">
                  {/* Add a wrapper div for horizontal scrolling */}
                  <div
                    style={{
                      overflowX: "auto", // Enables horizontal scrolling
                      whiteSpace: "nowrap", // Prevents the buttons from wrapping to the next line
                      paddingBottom: "8px", // Optional: Add padding to prevent the scrollbar from overlapping content
                    }}
                  >
                    <Radio.Group
                      value={selectedYears}
                      onChange={(e) => setSelectedYears(e.target.value)}
                      buttonStyle="solid"
                      // Note: The radioGroupStyle should ensure 'display: flex' is set
                      // but without 'flex-wrap: wrap' for this to work correctly.
                      // If radioGroupStyle includes 'flex-wrap: wrap', remove it.
                      style={{ ...radioGroupStyle, width: "max-content" }} // Ensure the group takes up all necessary space
                    >
                      {YEAR_OPTIONS.map((yr) => (
                        <Radio.Button key={yr} value={yr} style={buttonStyle}>
                          {yr}
                        </Radio.Button>
                      ))}
                    </Radio.Group>
                  </div>
                </Col>
              </Row>
              <Row
                gutter={[8, 8]}
                align="middle"
                style={{ marginBottom: "16px" }}
              >
                <Col>
                  <span
                    className="ant-form-item-label"
                    style={{ fontWeight: "normal" }}
                  >
                    months
                  </span>
                </Col>
                <Col flex="auto">
                  {/* Add a wrapper div for horizontal scrolling */}
                  <div
                    style={{
                      overflowX: "auto", // Enables horizontal scrolling
                      whiteSpace: "nowrap", // Prevents the buttons from wrapping to the next line
                      paddingBottom: "8px", // Optional: Add padding to prevent the scrollbar from overlapping content
                    }}
                  >
                    <Radio.Group
                      value={selectedMonths}
                      onChange={(e) => setSelectedMonths(e.target.value)}
                      buttonStyle="solid"
                      // Note: The radioGroupStyle should ensure 'display: flex' is set
                      // but without 'flex-wrap: wrap' for this to work correctly.
                      // If radioGroupStyle includes 'flex-wrap: wrap', remove it.
                      style={{ ...radioGroupStyle, width: "max-content" }} // Ensure the group takes up all necessary space
                    >
                      {MONTH_OPTIONS.map((mo) => (
                        <Radio.Button key={mo} value={mo} style={buttonStyle}>
                          {mo}
                        </Radio.Button>
                      ))}
                    </Radio.Group>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </div>

        {/* --- Note Field --- */}
        <Form.Item label="Note" name="note" style={{ marginBottom: "40px" }}>
          <Input.TextArea
            rows={3}
            placeholder="Type something" // Added placeholder from image
          />
        </Form.Item>

        {/* --- Footer Buttons (No standard footer used) --- */}
        <div className="text-end">
        
        </div>
      </Form>
    </Modal>
  );
}

MedicalDetailModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  selectedItem: PropTypes.string,
  type: PropTypes.string,
};
